/*
 * 错误列表
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React from 'react';
import { useSelector } from 'store/hook/useSelector';
import { Error_svg } from 'image/index';
import S from './index.less';
export default function ErrorList() {
    var _a = useSelector(function (state) { return state.data.extract; }), progress = _a.progress, taskId = _a.taskId, traceId = _a.traceId;
    // const model = UseModel()
    // const [baseInfo, compareInfo] = [UseFileInfo().useDisplayBase(), UseFileInfo().useDisplayCompare()]
    // const startComparison = () => {
    //     model.invokeAsync("startComparison", {
    //         baseFile: {
    //             fileName: baseInfo.name,
    //             url: baseInfo.url,
    //         },
    //         compareFile: {
    //             fileName: compareInfo.name,
    //             url: compareInfo.url,
    //         },
    //     })
    // }
    return (React.createElement("div", { className: S.errorList },
        React.createElement("img", { src: Error_svg, alt: '' }),
        React.createElement("div", { className: S.errorInfoBox },
            React.createElement("span", { className: S.mainError }, progress),
            React.createElement("span", { className: S.mainError },
                "taskId:",
                taskId),
            React.createElement("span", { className: S.mainError },
                "traceId:",
                traceId))));
}
